import React, {useState, useEffect} from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { Link } from 'gatsby';
import ProductItem from './ProductItem';
import { userLocation1 } from '../Helpers';
import { CLOTHING_PRODUCT_TEASER, JWELLERY_PRODUCT_TEASER, SHOES_PRODUCT_TEASER, ACCESSORIES_PRODUCT_TEASER } from '../Fragments/productTeaser';
import { useFilterState, useFilterDispatch } from '../Context/filterContext';
import { pagination } from './pagination';
import Filters from '../Filters/index';
import { useGlobalState, useGlobalDispatch } from '../Context/globalContext';
import singleViewIcon from '../../images/single-view.png';
import multipleViewIcon from '../../images/multiple-view.png';
import shoppingBag from '../../images/shopping-bag.png';
import PriceFilter from '../Filters/priceFilter';
import Loader from "react-loader-spinner";
const ProductList = ({
  context, category, gender, productTypeId, productTypeLabel, sortField, order, location
}) => {
  let Name = '', PageHeaderName = '';
  let productsAvailable = [];
  if (typeof window !== 'undefined') {
    const locationpath = window.location.href;
    const menuName = locationpath.split('/');
    Name = menuName[menuName.length-1];
    PageHeaderName = productTypeLabel || category || Name.charAt(0).toUpperCase() + Name.slice(1);
  }

  let queryText = '';
  if (location && location.state && location.state.queryText) {
    queryText = location.state.queryText;
  }

  const filterDispatch = useFilterDispatch();
  const {
    selectedCategory, selectedGender, productType, listContext, selectedOrder, selectedBoutique, isProductAvailable, loadingData, filteredProdcut
  } = useFilterState();
  const queryParams = {
    skip: 0,
    limit: 12,
  };
  const { lat, lng, adr } = useGlobalState();
  const globalDispatch = useGlobalDispatch();
  useEffect(() => {
    globalDispatch({type: 'meta', payload: {pageTitle: 'Products'}});
  }, []);
  const [isSingleView, setIsSingleView] = useState(false);
  const [isMultipleView, setIsMultipleView] = useState(false);
  const singleView = () => {
    setIsSingleView(!isSingleView);
    setIsMultipleView(false);
  };
  const multipleView = () => {
    setIsMultipleView(!isMultipleView);
    setIsSingleView(false);
  };
  const storeWithinRadius = [];
  if (selectedCategory && selectedCategory.length > 0) queryParams.category = selectedCategory;
  if (selectedBoutique && selectedBoutique.length > 0) queryParams.store = selectedBoutique;
  if (selectedGender && selectedGender.length > 0) queryParams.gender = selectedGender;
  if (productTypeId) {
    if (productType && !productType.includes(productTypeId)) {
      filterDispatch({ type: 'productTypeFilter', payload: productTypeId });
    }
    queryParams.productTypeId = productTypeId;
  }
  if (selectedOrder && Object.keys(selectedOrder).length > 0) {
    queryParams.order = [selectedOrder.order];
    queryParams.sortField = [selectedOrder.field];
  }
  const getSearchableData = (products) => {
    // Searching for realted data based on user search.
    // This is meant for search functionality.
    queryText = queryText.toLowerCase();
    const searchableData = products.filter((node) => {
      const { title } = node;
      // Regex match for valid characters.
      const regex = /^[A-Za-z0-9 ]+$/;
      const isValid = regex.test(queryText);
      if (!isValid) {
        return false;
      }
      // Regex to match searhable data with search query.
      const searchQuery = new RegExp('\\b' + `${queryText}` + '\\b');
      // Check for title match.
      if (title && searchQuery.test(title.toLowerCase(queryText))) {
        return true;
      }
      // Check for Store match.
      if (node.relationships.stores.length > 0 && searchQuery.test(node.relationships.stores[0].name.toLowerCase(queryText))) {
        return true;
      }
      // Check for category name match.
      if (node.relationships.field_categories && node.relationships.field_categories.length > 0) {
        for (let i = 0; i < node.relationships.field_categories.length; i++) {
          if (searchQuery.test(node.relationships.field_categories[i].name.toLowerCase(queryText))) {
            return true;
          }
        }
      }
    });
    // setSearchData(searchableData);
    return searchableData;
  };
  const { loading, data, fetchMore } = useQuery(GET_ALL_PRODUCTS, {
    variables: queryParams,
  });
  useEffect(() => {
    // Handling the result for category pages
    // Also Handles the visibility of filters wtr to category page.
    if (context === 'category') {
      if (listContext && !listContext.includes(context)) {
        filterDispatch({ type: 'listContextFilter', payload: context });
      }
      if (selectedCategory && !selectedCategory.includes(category)) {
        filterDispatch({ type: 'categoryFilter', payload: category });
      }
      if (gender && selectedGender && !selectedGender.includes(gender)) {
        filterDispatch({ type: 'genderFilter', payload: gender });
      }
      if (order && sortField && selectedOrder && !Object.keys(selectedOrder).includes(order)) {
        filterDispatch({ type: 'productPriceFilter', payload: { field: sortField, order: order } });
      }
    }
    if (!loading && data) {
      const { products, stores } = data;

      // Filter products as per location.
      // else display all products if location doesn't exist.
      if (lat) {
        const userLocation = { latitude: lat, longitude: lng };
        const promiseArray = stores.nodes.map(async ({ field_geolocation, drupal_id }) => {
          await userLocation1(field_geolocation, userLocation, drupal_id).then((message) => {
            if (message) storeWithinRadius.push(message);
          });
        });
        Promise.all(promiseArray).then(() => {
          const productsWithinRadius = (products.nodes.filter((product) => (storeWithinRadius.includes(product.relationships.stores[0].drupal_id) ? product.drupal_id : '')));
          productsAvailable = productsWithinRadius;
          if (!queryText) {
            filterDispatch({ type: 'setFilteredProdcut', payload: productsWithinRadius });
          }
          if (productsWithinRadius.length <= data.products.nodes.length) {
            // check for search query variable and display data as per search query.
            // Otherwise display the filtered data.
            if (queryText) {
              const searchedData = getSearchableData(productsWithinRadius);
              if (searchedData.length % 12 !== 0 || searchedData.length === 0) {
                const limit = 12 - (searchedData.length % 12);
                pagination(fetchMore, data.products.nodes.length, limit);
                if (limit === 1 || products.totalCount === data.products.nodes.length) {
                  filterDispatch({ type: 'setFilteredProdcut', payload: searchedData });
                }
              } else {
                filterDispatch({ type: 'setFilteredProdcut', payload: searchedData });
              }
            } else if (productsWithinRadius.length % 12 !== 0) {
              const limit = 12 - (productsWithinRadius.length % 12);
              pagination(fetchMore, data.products.nodes.length, limit);
            }
          }
          filterDispatch({ type: 'storesFilter', payload: storeWithinRadius });
          filterDispatch({ type: 'locationFilter', payload: true });
          filterDispatch({ type: 'setIsProductAvailable', payload: true });
        });
      } else {
        // check for search query variable and display data as per search query.
        // Otherwise display the unfiltered data. This will work when no location is provided.
        if (!queryText) {
          productsAvailable = products.nodes;
          filterDispatch({ type: 'setFilteredProdcut', payload: productsAvailable });
        } else {
          const searchedData = getSearchableData(products.nodes);
          productsAvailable = searchedData;
          if (searchedData.length % 12 !== 0) {
            const limit = 12 - (searchedData.length % 12);
            pagination(fetchMore, data.products.nodes.length, limit);
          }
          filterDispatch({ type: 'setFilteredProdcut', payload: searchedData });
        }
        filterDispatch({ type: 'locationFilter', payload: false });
        filterDispatch({ type: 'storesFilter', payload: storeWithinRadius });
        filterDispatch({ type: 'setIsProductAvailable', payload: true });
      }
    }
  }, [lat, data, queryText]);

  return (
    <>
    { !loadingData ? 
    <div className="sta-page-wrapper">
      <div className="cart-page-container-mobile">
        {(filteredProdcut.length > 0) && (
          !queryText ? <h3>{PageHeaderName}</h3> : <h3>Search Results for "{queryText}"</h3>
        )}
      </div>
    
      <div className="product-list-page-wrapper">
        <Filters />
          {(!filteredProdcut.length) || 
            (
              <div className={`product-view ${isSingleView ? ' single-view' : isMultipleView ? 'multiple-view' : ''}`}>
              <span className="single-product-image" onClick={() => singleView()}><img src={singleViewIcon} alt="Single Product view" /></span>
              <span className="multiple-product-image" onClick={() => multipleView()}>
              <img
                src={multipleViewIcon}
                alt="Multiple product view"
              />
            </span> 
          </div>
            )
          }
        <div className={`${!loading && !filteredProdcut.length && !loadingData ? 'w-full' : 'product-list-container'}`}>
          <div className="cart-page-container ">
            {(filteredProdcut.length > 0) && (
              !queryText ? <h3>{PageHeaderName}</h3> : <h3>Search Results for "{queryText}"</h3>
            )}
            {(!loading && !filteredProdcut.length && !loadingData) || <PriceFilter />}
          </div>
          <div className={`product-list-products ${isSingleView ? ' single-view' : isMultipleView ? 'multiple-view' : ''}`}>
            {(!loading && !filteredProdcut.length && !loadingData )
              ? (
                <div className="empty-message empty-cart">
                  <img src={shoppingBag} alt="your cart is empty" />
                  <h3>No products are available related to your search</h3>
                  <Link className="button-black" to="/products">Continue Shopping!</Link>
                </div>
              )
              : filteredProdcut.map((item) => <ProductItem key={item.drupal_id} product={item} />)}
          </div>
          <div className="product-list-button">
            {
              filteredProdcut.length && data && data.products && data.products.totalCount != data.products.nodes.length
              ? (
                <button className="button-black" onClick={() => pagination(fetchMore, data.products.nodes.length, 12)}>Load more</button>
              ) : null
              }
          </div>
        </div>
      </div>
    </div>
    : <Loader
        type="Circles"
        color="#00BFFF"
        height={100}
        width={100}
        className="loader"
      />
  }
  </>
  );
};
const GET_ALL_PRODUCTS = gql`
  query($productTypeId: String, $category: [String], $store:[String], $gender: [String], $skip: Int, $limit: Int, $sortField: [commerceProductFieldsEnum] = [created], $order: [SortOrderEnum] = [DESC]) {
    products: allCommerceProduct(filter: { status: {eq: true}, parent: {internal: {type: {nin: "commerce_product__customer_membership"}}} relationships: {commerce_product_type: {drupal_id: {eq: $productTypeId}} ,stores: {elemMatch: {name: {in: $store}, field_published: {eq: true}}} ,field_categories: {elemMatch: {name: {in: $category}, relationships: {parent: {elemMatch: {name: {in: $gender}}}}}}}}, skip: $skip, limit: $limit,  sort: {fields: $sortField, order: $order} ) {
      totalCount
      pageInfo {
        pageCount
        currentPage
      }
      nodes {
        title
        drupal_id
        path {
          alias
        }
        relationships {
          field_categories {
            name
          }
          stores {
            drupal_id
            name
          }
          variations {
            ...ClothingProductTeaser
            ...JewlleryProductTeaser
            ...ShoesProductTeaser
            ...AccessoriesProductTeaser
          }
      }
    }
    }
    stores: allCommerceStoreBoutique(filter: {field_published: {eq: true}}) {
      nodes {
        drupal_id
        name
        field_geolocation {
          lat
          lng
        }
      }
      }
}
${CLOTHING_PRODUCT_TEASER}
${JWELLERY_PRODUCT_TEASER}
${SHOES_PRODUCT_TEASER}
${ACCESSORIES_PRODUCT_TEASER}`;
export default ProductList;
